import { SUBMIT_QUERY } from '../actions/query';

export default function query(state='', action) {
  switch(action.type) {
    case SUBMIT_QUERY:
      return action.query
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/query.js